import Config from '../config'
import moment from 'moment'
import axios from "axios";
import {LOGGER} from "./Logger";

const functions = {
  getPaymentsForRes: function (token, resId) {
    return new Promise((resolve, reject) => {
      const url = `${Config.BACKEND_URL}payments?resId=${resId}`;
      const config = {
        method: 'get',
        url,
        headers: {Authorization: token, contentType: 'application/json'},
      };
      axios(config)
        .then((res) => {
          console.log('got payments for ', resId)
          resolve(res.data)
        })
        .catch((err) => {
          LOGGER.error('error when getting payments for reservation', err);
          reject(err)
        });
    })
  },

	getAttomData: async function(token, propertyId, address1, address2 ) {
		return new Promise(async(resolve, reject) => {
			const config = {
				method: 'get',
				url: `${Config.BACKEND_URL}attom/details`,
				headers: {Authorization: token, address1, address2, property_id: propertyId},
			}
			try {
				let res = await axios(config)
				if(res.status === 200 && res.data) resolve(res.data)
				else reject('Missing attom data')
			} catch (err) {
				LOGGER.error('Error when getting attom data', err)
				reject(err)
			}
		})
	},

	getZillowData: async function(token, property_address_line_one,property_address_city, property_address_region, property_address_postal_code) {
		return new Promise(async(resolve, reject) => {
			const config = {
				method: 'get',
				url: `${Config.BACKEND_URL}zillow/details`,
				headers: {Authorization: token},
				params: {
					property_address_line_one,
					property_address_city,
					property_address_region,
					property_address_postal_code
				}
			}
			try {
				let res = await axios(config)
				if(res.status === 200){
					if(res.data)
						resolve(res.data)
				}  else if(res.status === 400) reject(res.data)
				else reject('Missing attom data')
			} catch (err) {
				LOGGER.error('Error when getting zillow data', err.message)
				reject(err)
			}
		})
	}

}

export default functions
